/**
 * @generated SignedSource<<54dedfb03f2d5d4edbfeb558b41ec502>>
 * @relayHash 0b57255e6b2f4a82c11628bc8708dc5a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID de28ee6acd3c594568c536cb9b6b698a26a773f55ef20e585472ceefde7122cb

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraIssueArchiveAsyncInput = {
  jql: string;
};
export type services_archiveIssueAsyncMutation$variables = {
  cloudId: string;
  input: JiraIssueArchiveAsyncInput;
};
export type services_archiveIssueAsyncMutation$data = {
  readonly jira_archiveIssueAsync: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly __typename: "JiraIssueArchiveAsyncErrorExtension";
        readonly statusCode: number | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
    readonly taskId: string | null | undefined;
  } | null | undefined;
};
export type services_archiveIssueAsyncMutation = {
  response: services_archiveIssueAsyncMutation$data;
  variables: services_archiveIssueAsyncMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "taskId"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "services_archiveIssueAsyncMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraIssueArchiveAsyncPayload",
        "kind": "LinkedField",
        "name": "jira_archiveIssueAsync",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ],
                    "type": "JiraIssueArchiveAsyncErrorExtension"
                  }
                ]
              }
            ]
          },
          (v6/*: any*/)
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "services_archiveIssueAsyncMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraIssueArchiveAsyncPayload",
        "kind": "LinkedField",
        "name": "jira_archiveIssueAsync",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "type": "JiraIssueArchiveAsyncErrorExtension"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          },
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "de28ee6acd3c594568c536cb9b6b698a26a773f55ef20e585472ceefde7122cb",
    "metadata": {},
    "name": "services_archiveIssueAsyncMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e594e539ecd7bb3cb018b62ed8278301";

export default node;
